import React from 'react';

const AdvancedSearchPanel = ({
    advancedSearchFields,
    setAdvancedSearchFields,
    advancedFilters,
    setAdvancedFilters,
    handleAdvancedReset,
    handleAdvancedSearch,
}) => {
    return (
        <div className="advanced-search-panel">
            <div className="search-filter-row">
                <label>From</label>
                <input
                    type="text"
                    placeholder="Type a name or email"
                    value={advancedSearchFields.from}
                    onChange={(e) =>
                        setAdvancedSearchFields((prev) => ({
                            ...prev,
                            from: e.target.value,
                        }))
                    }
                />
            </div>

            <div className="search-filter-row">
                <label>To</label>
                <input
                    type="text"
                    placeholder="Type a name or email"
                    value={advancedSearchFields.to}
                    onChange={(e) =>
                        setAdvancedSearchFields((prev) => ({
                            ...prev,
                            to: e.target.value,
                        }))
                    }
                />
            </div>

            <div className="search-filter-row">
                <label>Subject</label>
                <input
                    type="text"
                    placeholder="Search subject"
                    value={advancedSearchFields.subject}
                    onChange={(e) =>
                        setAdvancedSearchFields((prev) => ({
                            ...prev,
                            subject: e.target.value,
                        }))
                    }
                />
            </div>

            <div className="search-filter-row">
                <label>Date</label>
                <select
                    value={advancedFilters.date}
                    onChange={(e) =>
                        setAdvancedFilters((prev) => ({
                            ...prev,
                            date: e.target.value,
                        }))
                    }
                >
                    <option>Any Time</option>
                    <option>Today</option>
                    <option>Last 7 Days</option>
                    <option>Last 30 Days</option>
                    <option>Custom Date</option>
                </select>
            </div>

            <div className="contains-filter-group">
                <button
                    type="button"
                    className={
                        advancedFilters.attachment ? 'filter-pill active' : 'filter-pill'
                    }
                    onClick={() =>
                        setAdvancedFilters((prev) => ({
                            ...prev,
                            attachment: !prev.attachment,
                        }))
                    }
                >
                    {advancedFilters.attachment ? '✓' : '📎'} Attachment
                </button>

                <button
                    type="button"
                    className={
                        advancedFilters.photo ? 'filter-pill active' : 'filter-pill'
                    }
                    onClick={() =>
                        setAdvancedFilters((prev) => ({
                            ...prev,
                            photo: !prev.photo,
                        }))
                    }
                >
                    {advancedFilters.photo ? '✓' : '🖼️'} Photo
                </button>

                <button
                    type="button"
                    className={
                        advancedFilters.calendar ? 'filter-pill active' : 'filter-pill'
                    }
                    onClick={() =>
                        setAdvancedFilters((prev) => ({
                            ...prev,
                            calendar: !prev.calendar,
                        }))
                    }
                >
                    {advancedFilters.calendar ? '✓' : '📅'} Calendar invite
                </button>
            </div>

            <div className="search-filter-row">
                <label>Search in</label>
                <select
                    value={advancedSearchFields.mailbox}
                    onChange={(e) =>
                        setAdvancedSearchFields((prev) => ({
                            ...prev,
                            mailbox: e.target.value,
                        }))
                    }
                >
                    <option>All Kuddlecore Mailboxes</option>
                    <option>Inbox</option>
                    <option>Sent</option>
                    <option>Drafts</option>
                    <option>Archive</option>
                    <option>Spam</option>
                    <option>Trash</option>
                </select>
            </div>

            <div className="search-filter-actions">
                <button
                    type="button"
                    className="reset-search-btn"
                    onClick={handleAdvancedReset}
                >
                    Reset
                </button>

                <button
                    type="button"
                    className="run-search-btn"
                    onClick={handleAdvancedSearch}
                >
                    Search
                </button>
            </div>
        </div>
    );
};

export default AdvancedSearchPanel;